import AsyncReactSelect from 'react-select/async';

import classNames from 'classnames';

import type { AsyncSelectProps } from './types/async-select.props';

import CheckboxOption from './components/checkbox-option.component';
import GroupHeading from './components/group-heading.component';
import Group from './components/group.component';
import MultiValue from './components/multi-value.component';
import Option from './components/option.component';
import VirtualMenuList from './components/virtual-menu-list.component';

import cssClasses from './select.module.css';

export function AsyncSelect<IsMulti extends boolean = false, Option = unknown>({
  className,
  useCheckboxOption = false,
  ...props
}: AsyncSelectProps<IsMulti, Option>) {
  const { components } = props;

  return (
    <AsyncReactSelect
      {...props}
      cacheOptions
      className={classNames(cssClasses.hspSelect, className)}
      classNamePrefix="hsp-select"
      components={{
        Group,
        GroupHeading,
        MenuList: VirtualMenuList,
        MultiValue,
        Option: useCheckboxOption ? CheckboxOption : Option,
        ...components,
      }}
      defaultOptions
    />
  );
}
